import React, {
  useContext,
  useState,
  useRef,
  useEffect,
  Fragment,
} from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
  useParams,
  useNavigate,
} from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import { FcPrevious, FcNext } from "react-icons/fc";
import {
  Menu,
  Transition,
  MenuButton,
  MenuItems,
  MenuItem,
} from "@headlessui/react";

import "./App.css";
import axios from "axios";
import CodeMirror from "@uiw/react-codemirror";
import { createTheme } from "@uiw/codemirror-themes";
import { sql, SQLDialect } from "@codemirror/lang-sql";
import { EditorView, keymap } from "@codemirror/view";
import Split from "react-split";
import DataTable from "./DataTable"; // Import your DataTable component
import Home from "./Home";
// const deepEqual = require('deep-equal');
// var deepEqual = require('fast-deep-equal');
import { BsListCheck } from "react-icons/bs";
import { BiLogoPostgresql } from "react-icons/bi";
import { SiPostgresql } from "react-icons/si";
import { ToastContainer, toast } from "react-toastify";
import {
  FaPlay,
  FaChevronLeft,
  FaChevronRight,
  FaLightbulb,
} from "react-icons/fa6";

import "react-toastify/dist/ReactToastify.css";
import logo from "./logo_img.png";

const lessons_array = [
  {
    id: 1,
    Lesson: "1. SELECT All",
  },
  {
    id: 2,
    Lesson: "2. SELECT column",
  },
  {
    id: 3,
    Lesson: "3. WHERE",
  },
  {
    id: 4,
    Lesson: "4. ORDER BY",
  },
  {
    id: 5,
    Lesson: "5. LIKE",
  },
  {
    id: 6,
    Lesson: "6. IN",
  },
  {
    id: 7,
    Lesson: "7. BETWEEN",
  },
  {
    id: 8,
    Lesson: "8. AND",
  },
  {
    id: 9,
    Lesson: "9. OR",
  },
  {
    id: 10,
    Lesson: "10. NOT",
  },
  {
    id: 11,
    Lesson: "11. IS NULL",
  },
  {
    id: 12,
    Lesson: "12. COUNT",
  },
  {
    id: 13,
    Lesson: "13. SUM",
  },
  {
    id: 14,
    Lesson: "14. MAX/MIN",
  },
  {
    id: 15,
    Lesson: "15. AVG ",
  },
  {
    id: 16,
    Lesson: "16. GROUP BY",
  },
  {
    id: 17,
    Lesson: "17. HAVING",
  },
  {
    id: 18,
    Lesson: "18. CASE",
  },
  {
    id: 19,
    Lesson: "19. DISTINCT",
  },
  {
    id: 20,
    Lesson: "20. INNER JOIN",
  },
  {
    id: 21,
    Lesson: "21. FULL JOIN",
  },
  {
    id: 22,
    Lesson: "22. LEFT JOIN",
  },
  {
    id: 23,
    Lesson: "23. RIGHT JOIN",
  },
  {
    id: 24,
    Lesson: "24. UNION",
  },
  {
    id: 25,
    Lesson: "25. UNION ALL",
  },
  {
    id: 26,
    Lesson: "26. RANK",
  },
  {
    id: 27,
    Lesson: "27. DENSE_RANK",
  },
  {
    id: 28,
    Lesson: "28. ROW_NUMBER",
  },
];

function Learnsql() {
  const [sqlQuery, setSqlQuery] = useState("");
  const [results, setResults] = useState([]);
  const [correct, setCorrect] = useState("");
  const [loading, setLoading] = useState(true);
  const [question, setQuestion] = useState();
  const [queryerror, setQueryerror] = useState("");
  const { id } = useParams();
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 650);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showHelpModal, setShowHelpModal] = useState(false);

  const navigate = useNavigate();
  const { logout, userId, firstName } = useContext(AuthContext);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 650);
    };

    // Attach the event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures that the effect runs only once on mount

  const backendUrl = "http://195.35.23.51:3001";

  const handlePrevPage = () => {
    // Assuming page is a string, you might want to convert it to a number
    const prevPage = parseInt(id, 10) - 1;
    // Redirect to the next page
    if (prevPage < 1) {
      return;
    }
    window.location.href = `/learnsql/${prevPage}`;
  };

  const handleNextPage = () => {
    // Assuming page is a string, you might want to convert it to a number
    const nextPage = parseInt(id, 10) + 1;
    // Redirect to the next page
    if (nextPage >= 10000) {
      return;
    }
    window.location.href = `/learnsql/${nextPage}`;
  };

  const handleQueryChange = (e) => {
    setSqlQuery(e);
  };

  const getLessonData = async () => {
    try {
      const response = await axios.get(
        `https://sqlguroo.com/api/get-lesson/${id}`
      );
      const specificData = response.data;
      setQuestion(specificData);
      console.log(specificData);
    } catch (error) {
      console.error("Error fetching specific data:", error);
    }
  };

  const executeQuery = async () => {
    setLoading(true);
    setCorrect("");
    setButtonDisabled(true);

    setTimeout(async () => {
      if (/DROP|ALTER/i.test(sqlQuery)) {
        setQueryerror("Only Select statements are allowed");
        console.log("Only Select statements are allowed");
        setResults([]);
        setTimeout(async () => {
          setButtonDisabled(false);
        }, 1400);
        return;
      }

      try {
        // let res = await axios.post('https://sqlguru-service.onrender.com/executeQuery/', { sqlQuery })

        let res = await axios.post(
          "https://sqlguroo.com/api/executeQuery/",
          { sqlQuery },
          {
            timeout: 5000, // Set the timeout to 5 seconds (5000 milliseconds)
          }
        );

        let { data } = res.data;
        setLoading(false);
        setResults(res.data);
        // console.log(res.data)
        console.log(results);
        setQueryerror("");
      } catch (e) {
        if (axios.isCancel(e)) {
          console.log("Request canceled:", e.message);
          setQueryerror(e.message);
          setResults([]);
        } else {
          console.log(e.response ? e.response.data.error : e);
          setQueryerror(e.response ? e.response.data.error : "Unknown Error");
          setResults([]);
        }
      }

      setButtonDisabled(false);
    }, 1400);
  };

  function areTablesEqual(tableA, tableB) {
    // Check if the tables have the same number of rows
    if (tableA.length !== tableB.length) {
      return false;
    }

    // Create arrays to store sorted row data for comparisonss
    const sortedTableA = [];
    const sortedTableB = [];

    // Sort the rows in both tables by their values
    for (const row of tableA) {
      const sortedRow = Object.values(row).sort();
      sortedTableA.push(sortedRow);
    }

    for (const row of tableB) {
      const sortedRow = Object.values(row).sort();
      sortedTableB.push(sortedRow);
    }

    // Sort the entire array to ensure consistent order
    sortedTableA.sort();
    sortedTableB.sort();

    // Compare the sorted arrays
    for (let i = 0; i < sortedTableA.length; i++) {
      for (let j = 0; j < sortedTableA[i].length; j++) {
        if (sortedTableA[i][j] !== sortedTableB[i][j]) {
          return false;
        }
      }
    }

    return true;
  }

  const submitQuery = async () => {
    if (results.length !== 0 && question !== null) {
      // Perform your processing on 'result' here
      // For example, you can log it or update other state variables

      setButtonDisabled(true);
      setCorrect("");

      setTimeout(async () => {
        try {
          const jsonString1 = JSON.stringify(question[0].output, null, 2);
          const jsonString2 = JSON.stringify(results, null, 2);

          console.log(jsonString1);
          console.log(jsonString2);

          // const areEqual = jsonString1 === jsonString2;

          const areEqual = areTablesEqual(question[0].output, results);

          if (areEqual) {
            setCorrect("Correct");
          } else {
            setCorrect("Incorrect");
          }
        } catch (error) {
          console.error("Error parsing JSON:", error);
          setCorrect("false");
        }
        setButtonDisabled(false);
      }, 1400);
    }
  };

  useEffect(() => {
    getLessonData();
  }, []);

  const KEYWORDS = [
    "select",
    "from",
    "where",
    "and",
    "or",
    "not",
    "in",
    "between",
    "contains",
    "array",
    "limit",
    "offset",
    "union",
    "intersect",
    "except",
    "order by",
    "asc",
    "desc",
  ];

  const TENSORS = ["images", "labels"];

  const dialect = SQLDialect.define({
    keywords: KEYWORDS.join(" "),
    builtin: TENSORS.join(" "),
  });

  const handleLogout = async () => {
    localStorage.clear();
    await logout();
    // navigate("/");
  };

  return (
    <div className="relative flex h-screen overflow-hidden bg-gray-50">
      {/* Main container */}
      <div
        className="relative flex flex-col 
                w-full 
                max-w-[98%]            
                2xl:max-w-[1820px]     
                mx-auto 
                h-screen 
                overflow-hidden"
      >
        {/* Top Navigation Bar - Redesigned */}
        <nav className="bg-white border-b border-gray-200 px-4 py-3 shadow-sm relative z-50">
          <div className="flex justify-between items-center w-full">
            {/* Left side: Logo and Navigation */}
            <div className="flex items-center gap-3">
              <Link to="/" className="flex-shrink-0">
                <div className="flex items-center text-5xl font-extrabold">
                  SQL
                  <div className="relative bg-blue-100 text-blue-800 text-xl font-semibold me-2 px-2.5 py-0.5 rounded ms-2 flex items-center">
                    Guroo
                    {firstName && (
                      <span className="ml-2 text-blue-500 font-normal">
                        | {firstName}
                      </span>
                    )}
                    <div className="absolute -top-3 -right-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-8 h-8"
                        viewBox="0 0 24 24"
                        style={{
                          transform: "rotate(25deg)",
                          color: "#1a1a1a", // Darker color
                        }}
                      >
                        {/* Main cap */}
                        <path
                          fill="currentColor"
                          d="M12 2L1 7l11 5 11-5-11-5zm0 6.5l-8-3.64V15l8 3.64 8-3.64V4.86l-8 3.64z"
                        />
                        {/* Tassel */}
                        <path
                          d="M21 7L21.5 8L27.5 24"
                          stroke="currentColor"
                          strokeWidth="1.2"
                          fill="none"
                          strokeLinecap="round"
                        />
                        {/* Tassel knot */}
                        <circle cx="21" cy="7" r="0.5" fill="currentColor" />
                      </svg>
                    </div>
                  </div>
                </div>
              </Link>

              {/* Lesson Navigation - Redesigned */}
              <div className="flex items-center ml-4 bg-gray-50 rounded-lg border border-gray-200 p-1">
                <button
                  onClick={handlePrevPage}
                  className={`flex items-center justify-center p-2 rounded-lg transition-all duration-200 ${
                    parseInt(id, 10) <= 1
                      ? "text-gray-300 cursor-not-allowed"
                      : "text-blue-600 hover:bg-blue-50"
                  }`}
                  disabled={parseInt(id, 10) <= 1}
                >
                  <FaChevronLeft className="h-4 w-4" />
                </button>

                <div className="px-3 mx-1 font-medium">
                  <span className="text-gray-500">Lesson</span>
                  <span className="mx-2 px-2 py-0.5 bg-blue-100 text-blue-800 rounded-md font-bold">
                    {id}
                  </span>
                  <span className="text-gray-500">of</span>
                  <span className="ml-2 text-gray-700 font-semibold">28</span>
                </div>

                <button
                  onClick={handleNextPage}
                  className={`flex items-center justify-center p-2 rounded-lg transition-all duration-200 ${
                    parseInt(id, 10) >= 28
                      ? "text-gray-300 cursor-not-allowed"
                      : "text-blue-600 hover:bg-blue-50"
                  }`}
                  disabled={parseInt(id, 10) >= 28}
                >
                  <FaChevronRight className="h-4 w-4" />
                </button>
              </div>

              {/* Help button */}
              <button
                onClick={() => setShowHelpModal(true)}
                className="inline-flex items-center gap-1.5 ml-2 py-1.5 px-3 rounded-md text-sm text-blue-600 bg-blue-50 hover:bg-blue-100 transition-colors"
              >
                <FaLightbulb className="h-3.5 w-3.5" />
                <span>SQL Help</span>
              </button>
            </div>

            {/* Right side: User Menu */}
            <div className="flex items-center gap-3">
              <Menu as="div" className="relative">
                <MenuButton className="flex items-center gap-2 p-2 rounded-full transition-colors hover:bg-gray-100">
                  <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center">
                    <span className="text-white text-sm font-medium">
                      {localStorage.getItem("firstName")?.charAt(0) || "U"}
                    </span>
                  </div>
                  <svg
                    className="w-4 h-4 text-gray-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </MenuButton>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <MenuItems className="absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="px-4 py-2 border-b border-gray-100">
                      <p className="text-sm font-medium text-gray-900">
                        {localStorage.getItem("firstName") || "User"}
                      </p>
                      <p className="text-xs text-gray-500">
                        {localStorage.getItem("username") || "user@example.com"}
                      </p>
                    </div>

                    <MenuItem>
                      {({ active }) => (
                        <Link
                          to="/profile"
                          className={`${
                            active ? "bg-gray-100" : ""
                          } flex items-center px-4 py-2 text-sm text-gray-700`}
                        >
                          <svg
                            className="mr-3 h-5 w-5 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            />
                          </svg>
                          Profile
                        </Link>
                      )}
                    </MenuItem>

                    <MenuItem>
                      {({ active }) => (
                        <Link
                          to="/settings"
                          className={`${
                            active ? "bg-gray-100" : ""
                          } flex items-center px-4 py-2 text-sm text-gray-700`}
                        >
                          <svg
                            className="mr-3 h-5 w-5 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                          </svg>
                          Settings
                        </Link>
                      )}
                    </MenuItem>

                    <div className="border-t border-gray-100">
                      <MenuItem>
                        {({ active }) => (
                          <button
                            onClick={handleLogout}
                            className={`${
                              active ? "bg-gray-100" : ""
                            } flex w-full items-center px-4 py-2 text-sm text-red-700`}
                          >
                            <svg
                              className="mr-3 h-5 w-5 text-red-400"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013 3v1"
                              />
                            </svg>
                            Sign out
                          </button>
                        )}
                      </MenuItem>
                    </div>
                  </MenuItems>
                </Transition>
              </Menu>
            </div>
          </div>
        </nav>

        {/* SQL Help Modal */}
        <dialog
          open={showHelpModal}
          className="modal"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setShowHelpModal(false);
            }
          }}
        >
          <div
            className="modal-box max-w-5xl bg-white rounded-lg shadow-xl border border-gray-100 overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between bg-blue-600 px-6 py-4">
              <div className="flex items-center gap-3">
                <SiPostgresql className="text-white text-2xl" />
                <h3 className="text-xl font-semibold text-white">
                  PostgreSQL Syntax Guide
                </h3>
              </div>
              <form method="dialog">
                <button className="btn btn-sm btn-circle bg-white/20 hover:bg-white/30 border-0 text-white">
                  ✕
                </button>
              </form>
            </div>

            <div className="p-6 overflow-y-auto max-h-[70vh]">
              <p className="text-gray-600 mb-4">
                Quick reference for commonly used PostgreSQL syntax. Hover over
                examples for more details.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-2 gap-4">
                {/* Basic SELECT Structure */}
                <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden h-full flex flex-col">
                  <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                      />
                    </svg>
                    <h4 className="font-medium text-sm">
                      Basic SELECT Structure
                    </h4>
                  </div>
                  <div className="p-3 flex-1">
                    <pre className="font-mono text-xs bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                      {`SELECT column1, column2
FROM table_name
WHERE condition
GROUP BY column1
HAVING condition
ORDER BY column1 [ASC|DESC]
LIMIT n;`}
                    </pre>
                  </div>
                </div>

                {/* Date/Time Functions */}
                <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden h-full flex flex-col">
                  <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    <h4 className="font-medium text-sm">Date/Time Functions</h4>
                  </div>
                  <div className="p-3 flex-1">
                    <p className="mb-1 text-xs text-gray-600">
                      Date comparison:
                    </p>
                    <pre className="font-mono text-xs bg-white p-1.5 rounded-md border border-gray-200 text-gray-800 mb-2 whitespace-pre-wrap">
                      {`date_column = DATE '2020-01-01'`}
                    </pre>
                    <p className="mb-1 text-xs text-gray-600">Extract parts:</p>
                    <pre className="font-mono text-xs bg-white p-1.5 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                      {`EXTRACT(MONTH FROM date_column)
EXTRACT(YEAR FROM date_column)
EXTRACT(DOW FROM date_column)`}
                    </pre>
                  </div>
                </div>

                {/* Aggregation Functions */}
                <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden h-full flex flex-col">
                  <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                      />
                    </svg>
                    <h4 className="font-medium text-sm">
                      Aggregation Functions
                    </h4>
                  </div>
                  <div className="p-3 flex-1">
                    <pre className="font-mono text-xs bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                      {`COUNT(*) -- count rows
SUM(column) -- sum values
AVG(column) -- average
MIN(column) -- minimum value
MAX(column) -- maximum value`}
                    </pre>
                  </div>
                </div>

                {/* JOIN Types */}
                <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden h-full flex flex-col">
                  <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                      />
                    </svg>
                    <h4 className="font-medium text-sm">JOIN Types</h4>
                  </div>
                  <div className="p-3 flex-1">
                    <p className="mb-1 text-xs text-gray-600">
                      Inner join (default):
                    </p>
                    <pre className="font-mono text-xs bg-white p-1.5 rounded-md border border-gray-200 text-gray-800 mb-2 whitespace-pre-wrap">
                      {`FROM table1 JOIN table2
ON table1.column = table2.column`}
                    </pre>
                    <p className="mb-1 text-xs text-gray-600">
                      Left join keeps all rows from table1:
                    </p>
                    <pre className="font-mono text-xs bg-white p-1.5 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                      {`FROM table1 LEFT JOIN table2
ON table1.column = table2.column`}
                    </pre>
                  </div>
                </div>

                {/* Window Functions */}
                <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden h-full flex flex-col">
                  <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                      />
                    </svg>
                    <h4 className="font-medium text-sm">Window Functions</h4>
                  </div>
                  <div className="p-3 flex-1">
                    <p className="mb-1 text-xs text-gray-600">
                      Rank products by price within category:
                    </p>
                    <pre className="font-mono text-xs bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                      {`SELECT 
  product_name,
  category,
  price,
  RANK() OVER (
    PARTITION BY category
    ORDER BY price DESC
  ) as price_rank
FROM products;`}
                    </pre>
                  </div>
                </div>

                {/* Common Table Expressions (WITH) */}
                <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden h-full flex flex-col">
                  <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                      />
                    </svg>
                    <h4 className="font-medium text-sm">
                      Common Table Expressions
                    </h4>
                  </div>
                  <div className="p-3 flex-1">
                    <pre className="font-mono text-xs bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                      {`WITH high_value_customers AS (
  SELECT customer_id, SUM(total) as total_spent
  FROM orders
  GROUP BY customer_id
  HAVING SUM(total) > 1000
)
SELECT c.name, hvc.total_spent
FROM customers c
JOIN high_value_customers hvc 
  ON c.id = hvc.customer_id
ORDER BY hvc.total_spent DESC;`}
                    </pre>
                  </div>
                </div>

                {/* String Functions */}
                <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden h-full flex flex-col">
                  <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
                      />
                    </svg>
                    <h4 className="font-medium text-sm">String Functions</h4>
                  </div>
                  <div className="p-3 flex-1">
                    <pre className="font-mono text-xs bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                      {`LOWER(string) -- convert to lowercase
UPPER(string) -- convert to uppercase
LENGTH(string) -- string length
SUBSTRING(string, start, length)
CONCAT(string1, string2, ...)
REPLACE(string, from, to)`}
                    </pre>
                  </div>
                </div>

                {/* Data Type Conversion */}
                <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden h-full flex flex-col">
                  <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                      />
                    </svg>
                    <h4 className="font-medium text-sm">
                      Data Type Conversion
                    </h4>
                  </div>
                  <div className="p-3 flex-1">
                    <pre className="font-mono text-xs bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                      {`-- Two equivalent methods:
CAST(expression AS type)
expression::type

-- Examples:
CAST(price AS integer)
order_date::date
amount::numeric(10,2)`}
                    </pre>
                  </div>
                </div>

                {/* CASE Statement */}
                <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden h-full flex flex-col">
                  <div className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5">
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M8 9l4-4 4 4m0 6l-4 4-4-4"
                      />
                    </svg>
                    <h4 className="font-medium text-sm">CASE Statement</h4>
                  </div>
                  <div className="p-3 flex-1">
                    <pre className="font-mono text-xs bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                      {`SELECT 
  name,
  price,
  CASE
    WHEN price < 20 THEN 'Budget'
    WHEN price < 50 THEN 'Mid-range'
    ELSE 'Premium'
  END AS price_category
FROM products;`}
                    </pre>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 px-6 py-4 flex justify-end border-t border-gray-200">
              <form method="dialog">
                <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-md transition-colors">
                  Close Reference
                </button>
              </form>
            </div>
          </div>
        </dialog>

        {/* Main content area - Redesigned */}
        <div className="mx-auto w-full h-full overflow-auto py-2">
          <div className="h-full rounded-xl border border-gray-200 bg-white shadow overflow-hidden flex flex-row">
            {/* Lesson sidebar - Redesigned */}
            <div className="overflow-auto rounded-l-xl border-r border-gray-100 bg-gray-50 p-2 w-54">
              <div className="mb-3 px-3 pt-2">
                <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                  Curriculum
                </h3>
              </div>
              <ul className="flex flex-col gap-1 text-sm font-medium">
                {lessons_array.map((item, index) => (
                  <li key={index} className="w-full">
                    <a
                      href={`/learnsql/${item.id}`}
                      className={`flex items-start justify-left gap-2 rounded-lg px-3 py-2 text-xs 2xl:text-sm transition-all duration-200
                                                ${
                                                  selectedItem === index ||
                                                  item.id === parseInt(id, 10)
                                                    ? "text-blue-700 bg-white shadow-sm border-l-4 border-blue-500"
                                                    : "text-gray-600 hover:bg-white hover:text-gray-800"
                                                }`}
                      onClick={() => setSelectedItem(index)}
                    >
                      {item.Lesson}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Split panels - Redesigned */}
            <Split
              sizes={[50, 50]}
              minSize={100}
              expandToMin={false}
              gutterSize={6}
              gutterAlign="center"
              snapOffset={30}
              dragInterval={1}
              direction="horizontal"
              cursor="col-resize"
              className="split flex flex-row overflow-hidden h-full flex-1"
              gutterClassName="bg-gray-200 hover:bg-blue-400 transition-colors duration-150"
            >
              {/* Left panel - Lesson content */}
              <div className="border-r border-gray-100 bg-white p-5 overflow-auto">
                <div className="max-w-3xl mx-auto">
                  {/* Lesson title */}
                  <div className="mb-6">
                    {/* <span className="inline-block px-2.5 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800 mb-2">
                                            Lesson {id}
                                        </span> */}
                    <h1 className="text-2xl font-bold text-gray-900 tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600">
                      {question ? (
                        question[0].lesson
                      ) : (
                        <div className="animate-pulse h-8 w-64 bg-gray-200 rounded"></div>
                      )}
                    </h1>
                  </div>

                  {/* Lesson content */}
                  <div className="prose prose-blue max-w-none mb-8">
                    {question ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: question[0].content,
                        }}
                      />
                    ) : (
                      <div className="animate-pulse space-y-3">
                        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                        <div className="h-4 bg-gray-200 rounded"></div>
                        <div className="h-4 bg-gray-200 rounded w-5/6"></div>
                      </div>
                    )}
                  </div>

                  {/* Example query */}
                  <div className="mb-8">
                    <h2 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                      <svg
                        className="w-5 h-5 mr-2 text-blue-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                        />
                      </svg>
                      Try this query
                    </h2>
                    <div className="bg-gray-800 rounded-lg overflow-hidden">
                      <div className="px-4 py-2 bg-gray-900 text-gray-300 text-xs font-mono flex justify-between">
                        <span>SQL Example</span>
                        <span className="text-gray-500">PostgreSQL 14</span>
                      </div>
                      <div className="p-2">
                        <CodeMirror
                          className="rounded"
                          extensions={[
                            sql({ dialect }),
                            EditorView.lineWrapping,
                          ]}
                          height="4rem"
                          value={question ? question[0].code : ""}
                          options={{ readOnly: true }}
                          theme="dark"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Explanation */}
                  <div className="mb-6">
                    <h2 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                      <svg
                        className="w-5 h-5 mr-2 text-blue-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      Explanation
                    </h2>
                    <div className="bg-blue-50 border-l-4 border-blue-500 rounded-r-lg px-4 py-3 text-blue-800">
                      {question ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: question[0].explain,
                          }}
                        />
                      ) : (
                        <div className="animate-pulse space-y-2">
                          <div className="h-4 bg-blue-200 rounded w-5/6"></div>
                          <div className="h-4 bg-blue-200 rounded w-3/4"></div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Right panel - SQL playground */}
              <div className="bg-white border-l border-gray-100">
                <Split
                  sizes={[60, 40]}
                  minSize={150}
                  expandToMin={false}
                  gutterSize={6}
                  gutterAlign="center"
                  snapOffset={30}
                  dragInterval={1}
                  direction="vertical"
                  cursor="row-resize"
                  className="overflow-hidden h-full"
                  gutterClassName="bg-gray-200 hover:bg-blue-400 transition-colors duration-150"
                >
                  {/* SQL editor area */}
                  <div className="flex flex-col h-full overflow-hidden">
                    <div className="flex justify-between items-center px-4 py-3 border-b border-gray-100">
                      <div className="flex items-center">
                        <SiPostgresql className="text-blue-500 mr-2 text-xl" />
                        <h2 className="text-sm font-semibold text-gray-700">
                          SQL Playground
                        </h2>
                      </div>
                      <button
                        onClick={executeQuery}
                        disabled={isButtonDisabled}
                        className={`inline-flex items-center gap-1.5 rounded-lg px-4 py-1.5 text-sm font-medium shadow-sm transition-all
                                                    ${
                                                      isButtonDisabled
                                                        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                        : "bg-blue-600 text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
                                                    }`}
                      >
                        {isButtonDisabled ? (
                          <>
                            <svg
                              className="animate-spin h-4 w-4 mr-1"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                            Processing...
                          </>
                        ) : (
                          <>
                            <FaPlay className="h-3 w-3" />
                            Run
                          </>
                        )}
                      </button>
                    </div>

                    <div className="flex-1 p-2 overflow-auto">
                      <CodeMirror
                        className="h-full rounded border border-gray-200"
                        indentWithTab={false}
                        extensions={[sql({ dialect })]}
                        placeholder="SELECT * FROM cars"
                        value={sqlQuery}
                        onChange={handleQueryChange}
                      />
                    </div>

                    {/* Feedback area */}
                    <div className="flex items-center justify-between px-4 py-2 border-t border-gray-100 bg-gray-50">
                      {/* Left side: Error messages */}
                      <div className="flex-1">
                        {queryerror && (
                          <div className="flex items-center text-red-600 text-sm">
                            <svg
                              className="h-4 w-4 mr-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                            {queryerror}
                          </div>
                        )}
                      </div>

                      {/* Right side: Correct/Incorrect feedback */}
                      <div>
                        {isButtonDisabled && !correct && !queryerror && (
                          <span className="inline-block animate-pulse text-blue-600 font-medium text-sm">
                            Executing query...
                          </span>
                        )}

                        {correct === "Correct" && (
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800">
                            <svg
                              className="h-4 w-4 mr-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                            Correct!
                          </span>
                        )}

                        {correct === "Incorrect" && (
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800">
                            <svg
                              className="h-4 w-4 mr-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                            Incorrect
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Results area */}
                  <div className="overflow-auto border-t border-gray-200">
                    <div className="px-4 py-3 border-b border-gray-100 bg-gray-50 flex items-center justify-between">
                      <h3 className="text-sm font-semibold text-gray-700">
                        Query Results
                      </h3>
                      {results && results.length > 0 && (
                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                          {Array.isArray(results) ? results.length : 0} rows
                        </span>
                      )}
                    </div>
                    <div className="p-2">
                      {isButtonDisabled && !results.length ? (
                        <div className="flex justify-center items-center h-32">
                          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                        </div>
                      ) : results && results.length > 0 ? (
                        <DataTable data={results} />
                      ) : (
                        <div className="flex flex-col items-center justify-center h-32 text-gray-500">
                          <svg
                            className="h-12 w-12 text-gray-300 mb-2"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="1.5"
                              d="M13 10V3L4 14h7v7l9-11h-7z"
                            />
                          </svg>
                          <span className="text-sm">
                            Run a query to see results
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </Split>
              </div>
            </Split>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Learnsql;
